package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
enum class NewsReactionType {
    LIKE,
    DISLIKE
}

@Serializable
data class NewsSurveyCreateRequest(
    val question: String,
    val options: List<String>
)

@Serializable
data class NewsSurveyUpdateRequest(
    val question: String,
    val options: List<String>
)

@Serializable
data class NewsCreateRequest(
    val title: String,
    val text: String,
    val imageUrl: String? = null,
    val survey: NewsSurveyCreateRequest? = null,
    val surveys: List<NewsSurveyCreateRequest>? = null
)

@Serializable
data class NewsUpdateRequest(
    val title: String,
    val text: String,
    val imageUrl: String? = null,
    val survey: NewsSurveyUpdateRequest? = null,
    val surveys: List<NewsSurveyUpdateRequest>? = null
)

@Serializable
data class NewsReactionRequest(
    val reaction: NewsReactionType
)

@Serializable
data class NewsSurveyAnswerRequest(
    val optionId: String
)

@Serializable
data class NewsCommentCreateRequest(
    val text: String
)

@Serializable
data class NewsCommentDTO(
    val id: String,
    val text: String,
    val authorId: String,
    val authorName: String,
    val createdAt: String
)

@Serializable
data class NewsSurveyOptionDTO(
    val id: String,
    val text: String,
    val votes: Int = 0
)

@Serializable
data class NewsSurveyDTO(
    val id: String,
    val question: String,
    val options: List<NewsSurveyOptionDTO> = emptyList(),
    val totalResponses: Int = 0,
    val mySelectedOptionId: String? = null
)

@Serializable
data class CommunityNewsDTO(
    val id: String,
    val communityId: String,
    val title: String,
    val text: String,
    val imageUrl: String? = null,
    val survey: NewsSurveyDTO? = null,
    val surveys: List<NewsSurveyDTO> = emptyList(),
    val authorId: String,
    val authorName: String,
    val createdAt: String,
    val updatedAt: String? = null,
    val likes: Int = 0,
    val dislikes: Int = 0,
    val myReaction: String? = null,
    val comments: List<NewsCommentDTO> = emptyList()
)
